import AiSpinner from '@groovehq/internal-design-system/lib/components/Ai/AiSpinner'
import AiError from '@groovehq/internal-design-system/lib/components/Ai/AiError'
import { useAi } from 'ducks/ai/hooks'
import { COMPOSER_TYPE } from 'ducks/ai/types'
import { styles } from './styles'

const AIOverlay = ({
  WrapperComponent = React.Fragment,
  wrapperProps = {},
  isNote = false,
}) => {
  const {
    requestState: { loading, error },
  } = useAi(COMPOSER_TYPE)

  if (!error && !loading) return null

  return (
    <WrapperComponent {...wrapperProps}>
      <div css={[styles.aiWrapper, isNote && styles.isNote]}>
        {error && <AiError />}
        {loading && <AiSpinner />}
      </div>
    </WrapperComponent>
  )
}

export default AIOverlay
